import { render, staticRenderFns } from "./AiDictManage.vue?vue&type=template&id=f25fdb0a&scoped=true&"
import script from "./AiDictManage.vue?vue&type=script&lang=js&"
export * from "./AiDictManage.vue?vue&type=script&lang=js&"
import style0 from "./AiDictManage.vue?vue&type=style&index=0&id=f25fdb0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25fdb0a",
  null
  
)

export default component.exports